module.exports = __webpack_public_path__ + "static/media/tn.c17b985c.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/tn.svg
// module id = 958
// module chunks = 0